import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class DocumentsTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'DocumentsTranslations'
  // Define default properties here
  static instanceDefaults () {
    return {
      documentId: null,
      text: '',
      localeId: null,
    }
  }
}
const servicePath = 'documents-translations'
const servicePlugin = makeServicePlugin({
  Model: DocumentsTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
